import { C } from "../lib/constants";
import { Btn } from "./ui/Btn";
import { Chip } from "./ui/Chip";

const WORK_FLOW = {
  pendiente:             { label:"Nueva solicitud",        color:C.accent,   icon:"🟠" },
  aceptada:              { label:"Aceptada",               color:C.blue,     icon:"🔵" },
  en_progreso:           { label:"En proceso",             color:C.green,    icon:"🟢" },
  completada:            { label:"Completada",             color:C.green,    icon:"✅" },
  cancelada:             { label:"Cancelada",              color:C.muted,    icon:"⚪" },
  mediacion_solicitada:  { label:"Mediación solicitada",   color:C.red,      icon:"🚨" },
  en_mediacion:          { label:"En mediación",           color:C.red,      icon:"⚖️" },
  accidente_reportado:   { label:"Accidente reportado",    color:C.red,      icon:"🚨" },
  nueva:                 { label:"Nueva cotización",       color:C.accent,   icon:"🟠" },
  cotizada:              { label:"Cotizada",               color:"#7B5EA7",  icon:"🟣" },
  autorizada:            { label:"Autorizada",             color:C.blue,     icon:"🔵" },
  en_proceso:            { label:"En proceso",             color:C.green,    icon:"🟢" },
  activa:                { label:"Obra activa",            color:C.green,    icon:"🟢" },
  finalizada:            { label:"Finalizada",             color:C.green,    icon:"✅" },
  cerrada:               { label:"Cerrada",                color:C.sub,      icon:"⬜" },
};
export const getFlowInfo = (status) => WORK_FLOW[status || "pendiente"] || WORK_FLOW.pendiente;

export const EstadoChip = ({status}) => { const i=getFlowInfo(status); return <Chip text={`${i.icon} ${i.label}`} color={i.color} small/>; };

export const FlowTimeline = ({status}) => {
  const steps=[['pendiente','Solicitud'],['aceptada','Aceptada'],['en_progreso','Proceso'],['completada','Final']];
  const idx=Math.max(0,steps.findIndex(([id])=>id===status));
  const conflict=['mediacion_solicitada','en_mediacion'].includes(status);
  return <div style={{display:'grid',gridTemplateColumns:`repeat(${steps.length},1fr)`,gap:4,margin:'12px 0'}}>{steps.map(([id,label],i)=>{
    const active=i<=idx||status==='completada';
    return <div key={id} style={{textAlign:'center'}}><div style={{height:5,borderRadius:5,background:conflict?C.red:(active?C.green:C.faint),marginBottom:5}}/><div style={{fontSize:9,color:active?C.text:C.muted,fontWeight:active?800:500}}>{label}</div></div>
  })}</div>;
};

export const MediationBox = ({solicitud}) => {
  if(!['mediacion_solicitada','en_mediacion'].includes(solicitud.estado || solicitud.status)) return null;
  return <div style={{background:C.redL,border:`1.5px solid ${C.red}35`,borderRadius:12,padding:'11px 13px',marginBottom:12}}>
    <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:5}}><span style={{fontSize:18}}>⚖️</span><div style={{color:C.red,fontSize:13,fontWeight:900}}>Mediación FICIO solicitada</div></div>
    <div style={{color:C.sub,fontSize:12,lineHeight:1.45}}>Costo de mediación: <strong>$500 MXN</strong>. FICIO revisa evidencia, comunicación y acuerdos para ayudar a resolver el conflicto.</div>
    {solicitud.mediation_reason&&<div style={{background:C.surface,borderRadius:9,padding:'8px 10px',fontSize:11,color:C.text,marginTop:8}}>Motivo: {solicitud.mediation_reason}</div>}
  </div>;
};

export const EmptyBox = ({icon,title,desc}) => (
  <div style={{textAlign:"center",padding:"42px 22px",background:C.surface,border:`1px solid ${C.border}`,borderRadius:18}}>
    <div style={{fontSize:52,marginBottom:10}}>{icon}</div>
    <div style={{fontFamily:"Georgia, serif",fontSize:19,fontWeight:900,color:C.text,marginBottom:5}}>{title}</div>
    <div style={{color:C.muted,fontSize:13,lineHeight:1.5}}>{desc}</div>
  </div>
);

export const MediacionModal = ({solicitud, reason, setReason, onClose, onConfirm}) => {
  if (!solicitud) return null;

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.65)",zIndex:600,display:"flex",alignItems:"flex-end",justifyContent:"center",padding:18}}>
      <div style={{background:C.surface,borderRadius:22,maxWidth:560,width:"100%",padding:22,boxShadow:"0 -8px 32px rgba(0,0,0,.25)"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
          <div>
            <div style={{fontFamily:"Georgia, serif",fontSize:22,fontWeight:900,color:C.text}}>Solicitar mediación</div>
            <div style={{color:C.muted,fontSize:12}}>Trabajo con {solicitud.cliente_nombre || solicitud.trabajador_nombre || "usuario"}</div>
          </div>
          <button onClick={onClose} style={{background:C.faint,border:"none",borderRadius:10,padding:"8px 12px",cursor:"pointer",color:C.sub}}>✕</button>
        </div>

        <div style={{background:C.redL,border:`1.5px solid ${C.red}35`,borderRadius:14,padding:"13px 14px",marginBottom:14}}>
          <div style={{color:C.red,fontSize:14,fontWeight:900,marginBottom:4}}>⚖️ Mediación FICIO · $500 MXN</div>
          <div style={{color:C.sub,fontSize:12,lineHeight:1.5}}>
            Se abre un proceso de revisión para resolver quejas del cliente o trabajador. FICIO podrá revisar evidencia, mensajes, acuerdos y avance del trabajo.
          </div>
        </div>

        <div style={{color:C.sub,fontSize:11,fontWeight:800,letterSpacing:.8,textTransform:"uppercase",marginBottom:8}}>
          Motivo de la mediación
        </div>
        <textarea
          value={reason}
          onChange={e=>setReason(e.target.value)}
          placeholder="Ej. El cliente no quiere pagar lo acordado / El trabajo no quedó conforme / Hubo cambio de alcance..."
          rows={5}
          style={{width:"100%",background:C.bg,border:`1.5px solid ${C.border}`,borderRadius:12,padding:"12px 14px",fontSize:13,color:C.text,outline:"none",resize:"vertical",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",marginBottom:14}}
        />

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          <Btn full outline color={C.muted} onClick={onClose}>Cancelar</Btn>
          <Btn full color={C.red} onClick={onConfirm}>Solicitar mediación</Btn>
        </div>
      </div>
    </div>
  );
};
